export const classes = (classes: Array<any>): string => {
  return classes.filter((item) => typeof item === "string").join(" ");
};
